import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import videojs from 'libraries/videojs';
import { withEffect } from 'mixins/withEffect';
import { EffectsContainer } from 'mixins/withEffects';
import WCCAudio from 'models/attachments/audio';
import './audio.html';
import './audio.scss';

const activePlayers = ko.observableArray<any>();

export interface WCCAudioVMConfig {
    audio: SubscribableOrNullableValue<WCCAudio>
    remove?: Action
}

@injectable()
export default class WCCAudioVM {
    private player = ko.observable<any>();
    private removeFunc?: Action

    labels = labels;
    settings = settings;

    audioNode = ko.observable<HTMLAudioElement>();

    isReady: Subscribable<boolean>
    isProcessingFile: Subscribable<boolean>
    isWaitingToProcessFile: Subscribable<boolean>
    hasControls: Subscribable<boolean>
    canBeRemoved: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: WCCAudioVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        const audio = ko.flattenComputed(config.audio);
        const audioURL = audio.pluck(a => a.fileUrl());

        const file = audio.pluck(a => a.file());
        const fileState = file.pluck(f => f.state());
        const fileName = audio.pluck(f => f.fileName());

        this.removeFunc = config.remove;
        this.canBeRemoved = ko.pureComputed(() => this.removeFunc != undefined);
        this.hasControls = ko.pureComputed(() => this.canBeRemoved());

        this.isProcessingFile = ko.pureComputed(() => fileState() != enums.UserFileState.Active.value && fileState() != enums.UserFileState.Preactivated.value);
        // filestate undefined means that the file is not being processed and user needs to submit post
        this.isWaitingToProcessFile = ko.pureComputed(() => fileState() == undefined || fileState() == enums.UserFileState.Unknown.value);
        this.isReady = ko.pureComputed(() => audioURL != undefined);

        effects.register(node => {
            let player: any;

            if (node != undefined) {
                player = videojs(node, {
                    controls: true,

                    controlBar: {
                        children: ['playToggle', 'progressControl']
                    }
                });

                player.on('play', () => {
                    activePlayers().forEach(otherPlayer => {
                        otherPlayer.pause();
                        _.delay(() => otherPlayer.currentTime(0), 100);
                    });

                    activePlayers([player]);
                }); 

                player.on('pause', () => {
                    activePlayers.remove(player);
                });

                player.on('ended', () => _.delay(() => player.currentTime(0), 100));

                return [
                    withEffect(url => {
                        if (url != undefined)
                            player.src({ src: url });
                    }, [audioURL]),

                    () => activePlayers.remove(player),
                    () => player.dispose()                    
                ];
            }

            this.player(player);
        }, [this.audioNode]);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isReady,

            'css': {
                'wcc-audio': true,
                'wcc-audio--with-controls': this.hasControls                
            }
        }, this);
    }

    remove = () => {
        this.removeFunc?.();
    }
}